export default function Loader() {
  return <div id="loading"></div>;
}
